export const getMonthFromString = (mon: string) => {
  const d = Date.parse(mon + "1, 2000");
  if (!isNaN(d)) {
    return new Date(d).getMonth() + 1;
  }
  return -1;
};
